import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import "LIBRARY/Components/Periodicals/PeriodicalsOrJournals/importPeriodicals/importPeriodicals.css";
import LibraryApiCall from 'LibraryApiCall';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import * as XLSX from "xlsx";

const papaparseOptions = {}

class ImportSubscription extends Component {
    constructor(props) {
        super(props)
        this.tableObject = {};
        this.myRef = React.createRef();
        this.state = {
            importSubscriptionModal: false,
            tabs: [
                { name: "Choose Excel File" },
                { name: "Start Import" }
            ],
            currentTab: 0,
            pageIndex: 1,
            limit: 10,
            PeriodicalTitle: "",

            csvData: [],
            postSubscriptionDetailsArray: [],
            postSubscriptionHeadersArray: [],

            validations: {
                headersErrors: [],
                dataErrors: {},
                errors: [],
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
                verificationHistory: {}
            },

            loadingVerificationProcess: false,
            verificationProgress: {
                completed: 0,
                failed: 0,
                total: 0,
                pending: 0
            },
            verificationPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },

            loadingImportProcess: false,
            importProgressSummary: { completed: 0, failed: 0, total: 0, pending: 0 },
            importPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },
            verifiedData: [],
            selectedCSVFiles: {},

            importProgress: [
                { name: "Verification", completed: false },
                { name: "Import", completed: false }
            ],
            currentProgress: 0,

            // Bug Console
            errorLogs: [],
            currentPointer: 0,
            currentErrorObject: {},
            fullScreen: false,

            errorMessageObjArray: [],
            preRequisiteFileName: 'Prerequisite Data.csv',

            //PreRequisite data
            preRequisiteCSVDataForFaculty: [
                { periodical: '', vender: '' },
                { periodical: '', vender: '' },
            ],

            preRequisiteData: [],

            preRequisiteCSVHeadersForFaculty: [
                { label: "Periodical", key: "periodical" },
                { label: "Vender", key: "vender" },
            ],

            preRequisiteHeaders: [],

            vendorList: {},
            vendorLoading: false,
            periodicalList: {},
            periodicalsLoading: false,

            verifyImportSubscriptionResult: '',  // set response of import invoice 
            loadingImportSubscriptionProcess: false,
            isImportButtonDisabled: false,

            iidPreRequisiteData: config.institute_id,
            iidImportSubscription: config.institute_id,

            ImportVendorList: {},
            ImportVendorLoading: false,
            ImportPeriodicalList: {},
            ImportPeriodicalsLoading: false
        }
    }

    componentDidMount() {
        // API Call for pre-requisite data
        this.getVendorDetailsList();
        this.getPeriodicalList();

        // API Call for import
        this.ImportGetVendorDetailsList();
        this.ImportGetPeriodicalList();

        // let preRequisiteData = this.state.preRequisiteCSVDataForFaculty
        // let preRequisiteHeaders = this.state.preRequisiteCSVHeadersForFaculty

        // this.setState({
        //     preRequisiteData: preRequisiteData,
        //     preRequisiteHeaders: preRequisiteHeaders,
        // })
    }

    componentDidUpdate(prevProps) {
        if (this.props.isShowImportSubscriptionButton != prevProps.isShowImportSubscriptionButton && this.props.isShowImportSubscriptionButton == true) {
            this.openImportSubscriptionModal()
        } else if (this.props.isShowImportSubscriptionButton != prevProps.isShowImportSubscriptionButton && this.props.isShowImportSubscriptionButton == false) {
            this.closeImportSubscriptionModal()
        }
    }

    // API Call For Pre-Requisite START

    // API CALL TO GET VENDER DATA LIST
    getVendorDetailsList = async () => {
        this.setState({
            vendorLoading: true
        });

        let requestData = {
            "iid": this.state.iidPreRequisiteData
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getVendorDetailsList',
            requestData,
            "/api/instructor/accountingManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getVendorDetailsList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.setState({
                        vendorList: apiResult.data,
                        vendorLoading: false
                    })
                }
                else {
                    this.setState({
                        vendorList: {},
                        vendorLoading: false
                    })
                }
            } else {
                this.setState({
                    vendorList: {},
                    vendorLoading: false
                })
            }
        }
    }

    // API CALL METHOD TO GET PERIODICAL LIST
    getPeriodicalList = async () => {

        this.setState({
            periodicalsLoading: true
        });

        let requestData = {
            "iid": this.state.iidPreRequisiteData,
            "filterData": {
                "title": '',
                "periodicity": '',
                "periodical_category_id": ''
            },
            "status": 'active'
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getPeriodicalList',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getPeriodicalList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            periodicalList: apiResult.data,
                            periodicalsLoading: false
                        });
                    } else {
                        this.setState({
                            periodicalList: {},
                            periodicalsLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        periodicalList: {},
                        periodicalsLoading: false
                    });
                }

            }
        }
    }

    // API Call For Pre-Requisite END

    // API Call Import START

    // API CALL TO GET VENDER DATA LIST
    ImportGetVendorDetailsList = async () => {
        this.setState({
            ImportVendorLoading: true
        });

        let requestData = {
            "iid": this.state.iidImportSubscription
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getVendorDetailsList',
            requestData,
            "/api/instructor/accountingManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.ImportGetVendorDetailsList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.setState({
                        ImportVendorList: apiResult.data,
                        ImportVendorLoading: true
                    })
                }
                else {
                    this.setState({
                        ImportVendorList: {},
                        ImportVendorLoading: false
                    })
                }
            } else {
                this.setState({
                    ImportVendorList: {},
                    ImportVendorLoading: false
                })
            }
        }
    }

    // API CALL METHOD TO GET PERIODICAL LIST
    ImportGetPeriodicalList = async () => {

        this.setState({
            ImportPeriodicalsLoading: true
        });

        let requestData = {
            "iid": this.state.iidImportSubscription,
            "filterData": {
                "title": '',
                "periodicity": '',
                "periodical_category_id": ''
            },
            "status": 'active'
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getPeriodicalList',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.ImportGetPeriodicalList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            ImportPeriodicalList: apiResult.data,
                            ImportPeriodicalsLoading: true
                        });
                    } else {
                        this.setState({
                            ImportPeriodicalList: {},
                            ImportPeriodicalsLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        ImportPeriodicalList: {},
                        ImportPeriodicalsLoading: false
                    });
                }

            }
        }
    }

    // API Call Import END

    // Import SUBSCRIPTION Modal Start From Here
    openImportSubscriptionModal = () => {

        const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['periodicals'].find(access => access === 'add');

        if (addGrantAccess !== undefined) {

            this.setState({
                importSubscriptionModal: true,
                isImportButtonDisabled: false
            })

        } else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }

    }

    closeImportSubscriptionModal = () => {
        this.setState({
            importSubscriptionModal: false,
            currentTab: 0,

            csvData: [],
            postSubscriptionDetailsArray: [],
            postSubscriptionHeadersArray: [],
            selectedCSVFiles: {},
            validations: {
                headersErrors: [],
                dataErrors: {},
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
            },
            verifiedData: [],
            loadingVerificationProcess: false,
            verificationProgress: {
                completed: 0,
                failed: 0,
                total: 0,
                pending: 0
            },
            verificationPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },

            loadingImportProcess: false,
            importProgressSummary: { completed: 0, failed: 0, total: 0, pending: 0 },
            importPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },
            verifiedData: [],
            selectedCSVFiles: {},

            importProgress: [
                { name: "Verification", completed: false },
                { name: "Import", completed: false }
            ],
            currentProgress: 0,

            // Bug Console
            errorLogs: [],
            currentPointer: 0,
            currentErrorObject: {},

        });
        // document.getElementById("react-csv-reader-input").value = '';
        // Clear the file input field using document.getElementById
        // const fileInput = document.getElementById("react-csv-reader-input");
        const fileInput = document.getElementById("react-excel-reader-input");
        if (fileInput) {
            fileInput.value = ''; // Reset the input value
        };

        this.props.closeImportModalForSubscription();
    }

    // OPEN FILE
    openFileInput = () => {
        // document.getElementById("react-csv-reader-input").click();
        document.getElementById("react-excel-reader-input").click();
    }

    // REMOVE SELECTED CSV FILE
    removeCSVFile = () => {
        this.setState({
            selectedCSVFiles: {},
            csvData: [],
            postSubscriptionDetailsArray: [],
            postSubscriptionHeadersArray: [],

            validations: {
                headersErrors: [],
                dataErrors: {},
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
            },
            selectedCSVFiles: {},
            verifiedData: [],
        });
        // document.getElementById("react-csv-reader-input").value = '';
        // Clear the file input field using document.getElementById
        // const fileInput = document.getElementById("react-csv-reader-input");
        const fileInput = document.getElementById("react-excel-reader-input");
        if (fileInput) {
            fileInput.value = ''; // Reset the input value
        }
    }

    // Import SUBSCRIPTION Modal
    importSubscriptionModal = () => {
        let resultFailedData = this.state.postSubscriptionDetailsArray.filter((item) => item.importStatus == 'failed')
        let resultSuccessData = this.state.postSubscriptionDetailsArray.filter((item) => item.importStatus == 'success')
        let resultPendingData = this.state.postSubscriptionDetailsArray.filter((item) => item.importStatus == 'pending')

        return (
            <>
                <div className={this.state.importSubscriptionModal ? 'modal fade show' : 'modal'} style={{ display: this.state.importSubscriptionModal ? "block" : 'none', visibility: this.state.importSubscriptionModal ? 'visible' : 'hidden' }}>
                    <div class="modal-dialog modal-lg--userdetails modal-dialog-centered" style={{ maxWidth: this.state.fullScreen ? '100vw' : '60vw', margin: this.state.fullScreen ? "0px auto" : "auto" }}>
                        <div class="modal-content modal-dialog-scrollable modal_content">
                            <div class="modal-header modal_header">
                                <h5 class="modal-title" style={{ textAlign: 'left' }} id="exampleModalLabel">Import Subscription Details</h5>
                                {this.state.loadingImportSubscriptionProcess || this.state.loadingImportProcess ?
                                    null :
                                    <span style={{ cursor: "pointer" }} onClick={() => {
                                        this.closeImportSubscriptionModal()
                                    }}>
                                        <FontAwesomeIcon icon={['fas', 'times']} size={'md'} />
                                    </span>
                                }
                            </div>
                            <div class="modal-body" style={{ maxHeight: this.state.fullScreen ? '100vh' : "80vh", height: this.state.fullScreen ? '100vh' : '80vh' }}>
                                <div className="">
                                    <div className="row">
                                        <div className="col">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="import-header">
                                                    {
                                                        this.state.tabs.map((item, index) => {
                                                            return (
                                                                <div className="tab-wrapper"><span className={this.state.currentTab == index ? "circle-tab" : "circle-tab-muted"}>{index + 1}</span><p className={this.state.currentTab == index ? "mb-0 mx-2" : "mb-0 mx-2 text-muted"}>{item.name}</p></div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                <button style={{ all: 'unset', cursor: "pointer" }} onClick={() => {
                                                    this.setState({
                                                        fullScreen: !this.state.fullScreen
                                                    })
                                                }}>
                                                    {
                                                        this.state.fullScreen ?
                                                            (
                                                                <span>
                                                                    <span style={{ border: '2px solid #000', padding: '2px' }} title={"Compress Edit Mode"}><FontAwesomeIcon icon={['fas', 'compress-alt']} size={'1x'}></FontAwesomeIcon></span>
                                                                </span>
                                                            ) :
                                                            (
                                                                <span>
                                                                    <span style={{ border: '2px solid #000', padding: '2px' }} title={"Expand Edit Mode"}><FontAwesomeIcon icon={['fas', 'expand-alt']} size={'1x'}></FontAwesomeIcon></span>
                                                                </span>
                                                            )
                                                    }
                                                </button>
                                            </div>

                                            {
                                                this.state.currentTab == 0 && this.chooseFileComponent()
                                            }
                                            {
                                                this.state.currentTab == 1 && this.importCSVFileComponent()
                                            }

                                            <div className="import-footer">
                                                {
                                                    this.state.currentTab == 1 &&

                                                    <div style={{ width: '100%', margin: '0px 10px 0 0' }}>

                                                        {
                                                            <div className="d-flex align-items-center flex-wrap" style={{ display: this.state.loadingImportProcess ? '' : 'none !important' }}>
                                                                {
                                                                    <>
                                                                        <ProgressBar bgcolor={"#6a1b9a"} completed={this.state.importProgressSummary['completed']} failed={this.state.importProgressSummary['failed']} total={this.state.importProgressSummary['total']} pending={this.state.importProgressSummary['pending']} />
                                                                        <p className="mb-0 font-weight-bold" style={{ fontSize: 14 }}>Import Progress: {(this.state.importProgressSummary['total'] - this.state.importProgressSummary['pending'])} | {this.state.importProgressSummary['total']}</p>
                                                                    </>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    this.state.currentTab == 0 && this.state.csvData.length > 0 && this.state.validations['isHeadersValid'] && (
                                                        <button type="button" className="btn import-btn" onClick={() => {
                                                            this.setState({
                                                                currentTab: 1
                                                            })
                                                        }}>
                                                            Proceed
                                                        </button>
                                                    )
                                                }
                                                {
                                                    this.state.currentTab == 1 && (
                                                        <>

                                                            {
                                                                this.state.validations['isVerified'] ?
                                                                    <span className="d-flex align-items-center text-success-color font-size14 font-weight-bold">
                                                                        <FontAwesomeIcon icon={['fas', 'check-circle']} size={'md'} className="mx-1"></FontAwesomeIcon> Verified
                                                                    </span>
                                                                    :
                                                                    resultPendingData?.length > 0 || resultFailedData?.length > 0 ?
                                                                        this.state.loadingImportProcess ? <ButtonLoader /> :
                                                                            <button type="button" className="btn import-btn" disabled={this.state.validations['isVerified']}
                                                                                onClick={() => {

                                                                                    let importProgressSummary = { completed: 0, failed: 0, total: this.state.postSubscriptionDetailsArray.length, pending: this.state.postSubscriptionDetailsArray.length }
                                                                                    this.setState({
                                                                                        loadingImportProcess: true,
                                                                                        importProgressSummary
                                                                                    }, () => {

                                                                                        this.apiCallToImportVerifySubscriptionDetails(0, this.state.importProgressSummary)
                                                                                    })
                                                                                }

                                                                                }
                                                                            >
                                                                                Verify
                                                                            </button>

                                                                        : null

                                                            }

                                                            {(resultSuccessData?.length > 0 && this.state.loadingImportProcess == false && resultFailedData?.length == 0) ?
                                                                this.state.loadingImportSubscriptionProcess ? <ButtonLoader /> :
                                                                    < button type="button" className="btn import-btn" disabled={this.state.isImportButtonDisabled} onClick={() => {
                                                                        this.setState({
                                                                            loadingImportSubscriptionProcess: true
                                                                        }, () => {
                                                                            this.apiCallToAddSubscriptionDetails(0)
                                                                        })
                                                                    }
                                                                    }>
                                                                        Import
                                                                    </button>
                                                                : null
                                                            }

                                                            {/* {
                                                                this.checkImportStatus() ?
                                                                    <span className="d-flex align-items-center text-success-color font-size14 font-weight-bold">
                                                                        <FontAwesomeIcon icon={['fas', 'check-circle']} size={'md'} className="mx-1"></FontAwesomeIcon> Imported Successfully
                                                                    </span>
                                                                    :
                                                                    <>
                                                                        <button type="button" className="btn import-btn" onClick={() => {

                                                                            let importProgressSummary = { completed: 0, failed: 0, total: this.state.postSubscriptionDetailsArray.length, pending: this.state.postSubscriptionDetailsArray.length }
                                                                            this.setState({
                                                                                loadingImportProcess: true,
                                                                                importProgressSummary
                                                                            }, () => {

                                                                                // this.apiCallToImportSubscriptionDetails(0, this.state.importProgressSummary)
                                                                            })
                                                                        }

                                                                        }>
                                                                            Import
                                                                        </button>
                                                                    </>
                                                            } */}
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.importSubscriptionModal && <div className="modal-backdrop fade show"></div>}
            </>
        )
    }

    // export subscription details into excel format
    exportData = () => {
        // Define the CSV headers
        const headers = [
            "Periodical Title*", "Vendor", "Subscription Start Date*", "Subscription End Date*", "Number Of Expected Issues", "Average Price Per Copy*"
        ];

        // Adding sample hard-coded data
        const sampleData = [
            ["Sample Periodical 1", "VM Pvt Ltd", "2025-01-01", "2025-12-30", "5", "50"],
        ];

        const fileName = 'Subscription Details.xlsx';
        const rowData = [];

        // Loop through the resource data and generate rows for the table
        sampleData.map(data => {
            const row = [
                data[0] || '', // Title
                data[1] || '', // Vendor
                data[2] || '', // Start Date
                data[3] || '', // End Date
                data[4] || '', // Number Of Expected Issues
                data[5] || '', // Average Price Per Copy
            ];

            // Add the row to the data
            rowData.push(row);
        });

        // Create the worksheet with headers and data
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rowData]);

        // Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Write the file (download the .xlsx file)
        XLSX.writeFile(workbook, fileName);

    };

    // download pre-requisite data in excel format
    exportPreRequisiteData = () => {
        // Define the CSV headers
        const headers = this.state.preRequisiteCSVHeadersForFaculty.map(header => header.label);
        let preRequisiteData = this.state.preRequisiteCSVDataForFaculty

        const fileName = 'PreRequisite_Subscription_Details.xlsx';
        const rowData = [];

        // For Vender
        if (Object.values(this.state.vendorList).length > 0) {
            Object.keys(this.state.vendorList).map((stream, index) => {
                let vender = this.state.vendorList[stream]
                if (vender != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].vender = vender.displayname
                    } else {
                        preRequisiteData.push({ periodical: '', vender: vender.displayname })
                    }
                }
            })
        }

        // For periodical list
        if (Object.values(this.state.periodicalList).length > 0) {
            Object.keys(this.state.periodicalList).map((Id, index) => {
                let category = this.state.periodicalList[Id]
                if (category != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].periodical = category.title
                    } else {
                        preRequisiteData.push({ periodical: category.title, vender: '' })
                    }
                }
            })
        }


        // Loop through the resource data and generate rows for the table
        preRequisiteData.forEach(resource => {
            const row = this.state.preRequisiteCSVHeadersForFaculty.map(header => {
                // Access each key dynamically from resource using the header key
                return resource[header.key] || ''; // If no value exists, return an empty string
            });

            // Add the row to the data
            rowData.push(row);
        });

        // Create the worksheet with headers and data
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rowData]);

        // Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Write the file (download the .xlsx file)
        XLSX.writeFile(workbook, fileName);
    };

    // display excel data onchange of choose file
    handleExcelInput = (event) => {
        const file = event.target.files[0];

        const fileDetails = {
            name: file.name,
            lastModified: file.lastModified,
            lastModifiedDate: file.lastModifiedDate,
            webkitRelativePath: file.webkitRelativePath,
            size: file.size,
            type: file.type
        };


        this.setState({
            selectedCSVFiles: fileDetails
        })

        if (!file) {
            this.setState({
                successModalType: "error",
                successMessage: "No file selected.",
                isValidAttachment: false,
                successModal: true,
            });
            return;
        }

        if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
            file.type !== "application/vnd.ms-excel") {
            this.setState({
                selectedCSVFiles: {},
                successModalType: "error",
                successMessage: "Please select a valid Excel file.",
                isValidAttachment: false,
                successModal: true,
            })
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const binaryData = e.target.result;
            const workbook = XLSX.read(binaryData, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });

            this.processExcelData(sheetData);
        };

        reader.readAsBinaryString(file);
    }

    processExcelData = (sheetData) => {
        if (sheetData.length === 0) {
            this.setState({
                successModalType: "error",
                successMessage: "Excel file is empty.",
                isValidAttachment: false,
            });
            return;
        }

        const headers = sheetData[0];
        const rows = sheetData.slice(0);

        let postSubscriptionDetailsArray = [];
        let postSubscriptionHeadersArray = [];
        // let validations = this.state.validations;
        // let headersArrayObject = this.state.preRequisiteCSVHeadersForStudentMarks;

        // // Validate headers
        if (headers != undefined && headers.length > 0) {
            headers.map((headerName, index) => {
                if (headerName != undefined && headerName.trim() !== "") {
                    postSubscriptionHeadersArray.push(headerName.trim());
                }
            })
        } else {
            toast.warn("Invalid headers found in imported excel file.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }

        // Find the index of the column
        const subscriptionStartDate = postSubscriptionHeadersArray.indexOf("Subscription Start Date*");
        const subscriptionEndDate = postSubscriptionHeadersArray.indexOf("Subscription End Date*");

        // Read Excel Actual Body Data including date
        if (postSubscriptionHeadersArray.length > 0) {
            rows.map((csvRow, index) => {
                if (index !== 0) {
                    let resourceObject = {};

                    for (let i = 0; i < postSubscriptionHeadersArray.length; i++) {
                        let value = csvRow[i];

                        // Format the "Subscription Start Date" if it exists and is a valid date
                        if (i === subscriptionStartDate && value) {
                            let formattedDate = this.formatDate(value);  // Format the date
                            value = formattedDate;  // Assign the formatted date
                        }

                        // Format the "Subscription end Date" if it exists and is a valid date
                        if (i === subscriptionEndDate && value) {
                            let formattedDate = this.formatDate(value);  // Format the date
                            value = formattedDate;  // Assign the formatted date
                        }

                        // Add the value to the resource object
                        resourceObject[postSubscriptionHeadersArray[i]] = value === undefined || value === null ? "" : value;
                    }

                    // Add the updated resource object to the final array
                    postSubscriptionDetailsArray.push({
                        ...resourceObject,
                        verificationStatus: "pending",
                        importStatus: "pending",
                        loading: false
                    });
                }
            });
        }

        this.setState({
            csvData: [...rows],
            postSubscriptionDetailsArray: postSubscriptionDetailsArray,
            postSubscriptionHeadersArray: postSubscriptionHeadersArray
        }, () => {
            this.validateCSVFileHeaders();

        })
    };

    formatDate = (dateValue) => {
        // If the value is a number (Excel timestamp), convert it to a JavaScript date
        if (typeof dateValue === 'number') {
            const excelStartDate = new Date(Date.UTC(1900, 0, 1));  // Use UTC to avoid timezone effects
            excelStartDate.setUTCDate(excelStartDate.getUTCDate() + dateValue - 2); // Adjust for the 1900 leap year bug
            return this.formatDateString(excelStartDate); // Format as YYYY-MM-DD
        }

        // If it's a string, try to parse it as a date in multiple formats
        const parsedDate = this.tryParseDate(dateValue);
        if (parsedDate) {
            return this.formatDateString(parsedDate); // Format as YYYY-MM-DD
        } else {
            return "";  // Return empty if the value is not a valid date
        }
    };

    // Helper function to try parsing the date from multiple formats
    tryParseDate = (dateValue) => {
        // Try parsing a string as an ISO date format (YYYY-MM-DD)
        let parsedDate = new Date(dateValue);
        if (parsedDate instanceof Date && !isNaN(parsedDate)) {
            return parsedDate; // Return parsed date if valid
        }

        // If it doesn't work, try parsing using a format like '10 Nov 2024'
        parsedDate = Date.parse(dateValue);
        if (!isNaN(parsedDate)) {
            return new Date(parsedDate); // Return parsed date if valid
        }

        return null;  // Return null if the date can't be parsed
    };

    // Helper function to format the date object as YYYY-MM-DD
    formatDateString = (date) => {
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
        const day = String(date.getUTCDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // CHOOSE SUBSCRIPTION COMPONENT
    chooseFileComponent = () => {
        return (
            <>
                <div className="import-info">
                    <div className="import-info-title ">
                        <p className="import-h5">Steps to import Subscription Details:</p>
                    </div>
                    <ol className="instruction-list mt-2 mb-2">
                        <li>Subscription Details can be imported in excel format.</li>
                        <li>Excel should be in specified format for import to work correctly.</li>
                        <li>
                            Refer the below example while adding content to the excel.  &nbsp;
                            {/* onClick={() => this.props.export()} */}
                            <span className="download-links font-weight-bold" onClick={() => this.exportData()}>
                                Download Sample Excel File
                                &nbsp;<FontAwesomeIcon icon={['fas', 'download']} size={'md'}></FontAwesomeIcon>
                            </span>
                            {this.props.csvLoading &&
                                <span> &nbsp;<FontAwesomeIcon icon={['fas', 'circle-notch']} size={'md'} className='rotate' style={{ color: '#0465AC' }} /></span>
                            }
                        </li>
                        <li>Select Institute to get Pre Requisite Data.
                            <select
                                className="form-control formControlContentTask"
                                style={{
                                    width: 'auto',
                                    height: '42px',
                                    fontSize: "13px",
                                    fontWeight: 400,
                                    lineHeight: '20px',
                                    fontFamily: "'Poppins', sans-serif",
                                    color: '#808080',
                                    borderRadius: '7px'
                                }}
                                onChange={(e) => {
                                    let selectedIIDValue = e.target.value;
                                    this.setState({ iidPreRequisiteData: selectedIIDValue }, () => {
                                        this.getVendorDetailsList();
                                        this.getPeriodicalList();
                                    })
                                }}
                                value={this.state.iidPreRequisiteData}
                            >
                                {Object.values(this.props?.multipleInstituteDetails?.multipleInstituteDetails || {}).map((member) => (
                                    <option key={member?.iid} value={member?.iid}>
                                        {member?.institute_name}
                                    </option>
                                ))}
                            </select>
                        </li>
                        <li>Refer the prerequire data to import.
                            {/* <CSVLink
                                onFileLoaded={this.state.preRequisiteData}
                                data={this.state.preRequisiteData}
                                id='downloadPreRequisitePostEventDetails'
                                headers={this.state.preRequisiteHeaders}
                                filename={this.state.preRequisiteFileName}
                            > */}
                            <span
                                className={`download-links font-weight-bold ${(!this.state.vendorLoading && !this.state.periodicalsLoading) ? 'download-links' : 'disabledLink'}`}
                                onClick={(subscription) => {
                                    if (
                                        !this.state.vendorLoading &&
                                        !this.state.periodicalsLoading
                                    ) {
                                        // Allow the download
                                        // this.downloadPrerequisitedataCSV();
                                        this.exportPreRequisiteData()
                                    } else {
                                        // Prevent the download
                                        subscription.preventDefault();
                                    }
                                }}
                            >
                                Download Prerequisite Excel File <FontAwesomeIcon icon={['fas', 'download']} size={'md'}></FontAwesomeIcon>
                            </span>
                            {/* </CSVLink> */}
                        </li>
                    </ol>

                    <div className="import-info-preview">
                        {
                            this.state.csvData.length > 0 ? (
                                <div className="table-responsive" style={{ overflowY: 'auto', height: '250px' }}>
                                    <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                                        <thead>
                                            {
                                                this.state.postSubscriptionHeadersArray.map((item) => {
                                                    return (
                                                        <th>{item}</th>
                                                    )
                                                })
                                            }
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.postSubscriptionDetailsArray.map((item, index) => {
                                                    if (item != undefined) {
                                                        return (
                                                            <tr>
                                                                {
                                                                    this.state.postSubscriptionHeadersArray.map((keys) => {
                                                                        if (typeof item[keys] == 'object') {
                                                                            return <td>{item[keys]['value']}</td>
                                                                        } else {
                                                                            return <td>{item[keys]}</td>
                                                                        }
                                                                    })
                                                                }

                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            ) : <span className="initial-preview"><FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999"></FontAwesomeIcon><p className="mx-2">After choosing file, You can view content here.</p></span>
                        }

                    </div>

                </div>
                <div className="import-info-note mt-2 mb-3">
                    <p>Once you download the sample Excel file. Update the necessary content. In order to import the updated file you have to upload by clicking on the button mentioned below.</p>
                </div>
                <div className="import-body">
                    Select Institute to Import Subscription
                    <select
                        className="form-control formControlContentTask"
                        style={{
                            width: 'auto',
                            height: '42px',
                            fontSize: "13px",
                            fontWeight: 400,
                            lineHeight: '20px',
                            fontFamily: "'Poppins', sans-serif",
                            color: '#808080',
                            borderRadius: '7px'
                        }}
                        onChange={(e) => {
                            let selectedIIDValue = e.target.value;
                            this.setState({ iidImportSubscription: selectedIIDValue }, () => {
                                this.ImportGetVendorDetailsList();
                                this.ImportGetPeriodicalList();
                            })
                        }}
                        value={this.state.iidImportSubscription}
                    >
                        {Object.values(this.props?.multipleInstituteDetails?.multipleInstituteDetails || {}).map((member) => (
                            <option key={member?.iid} value={member?.iid}>
                                {member?.institute_name}
                            </option>
                        ))}
                    </select>
                    <div className="d-flex align-items-center flex-wrap">
                        <div style={{ display: "none" }}>
                            <form ref={this.myRef}>
                                <input
                                    type="file"
                                    id="react-excel-reader-input"
                                    accept=".xlsx, .xls"
                                    onChange={this.handleExcelInput}
                                    style={{ display: 'none' }}
                                />
                            </form>
                            {/* <CSVReader
                                cssClass="csv-reader-input"
                                label="Select CSV file"
                                onFileLoaded={this.handleCSVInput}
                                parserOptions={papaparseOptions}
                            /> */}
                        </div>
                        <button type="button" className="btn import-btn" onClick={this.openFileInput}>
                            <FontAwesomeIcon icon={['fas', 'paperclip']} size={'lg'} color={"#FFF"}></FontAwesomeIcon> Choose File
                        </button>
                        {
                            Object.keys(this.state.selectedCSVFiles).length > 0 ?
                                <span>
                                    <span>
                                        {this.state.selectedCSVFiles['name']}
                                        <span style={{ "cursor": 'pointer' }} onClick={() => {
                                            this.removeCSVFile()
                                            this.myRef.current.reset()
                                        }}>
                                            <FontAwesomeIcon icon={['fas', 'times']} size={'md'}></FontAwesomeIcon>
                                        </span>
                                    </span>
                                </span>
                                : <p className="mb-0"><span className="text-danger">*</span> Please choose your excel file to import subscription details</p>
                        }
                    </div>
                </div>
                {
                    this.state.csvData.length > 0 && !this.state.validations['isHeadersValid'] &&
                    <div className="alert alert-danger" style={{ maxHeight: '20vh', overflow: "auto" }}>
                        {
                            Object.values(this.state.validations['headersErrors']).map((item) => {
                                return <p className="text-danger my-2">Header {item.cell}-{item.message}</p>
                            })
                        }
                    </div>
                }
            </>
        )
    }

    // IMPORT CSV FILE COMPONENT 
    importCSVFileComponent = () => {
        return (
            <>
                <div className="previw-sheet" style={{ minHeight: '40vh' }}>
                    {
                        this.state.csvData.length > 0 ? (
                            <div className="table-responsive" >
                                <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                                    <thead>
                                        <th className="td-dense">{"Sr. No."}</th>
                                        <th className="td-dense">{"Status"}</th>
                                        {/* {this.state.currentProgress == 0 ? "Error Location" : } */}
                                        {
                                            this.state.postSubscriptionHeadersArray.map((item) => {
                                                return (
                                                    <th className="td-dense">
                                                        {item === 'Title' ? (
                                                            <>
                                                                {item} <span className="text-danger">*</span>
                                                            </>
                                                        ) : (
                                                            item
                                                        )}
                                                    </th>
                                                )
                                            })
                                        }
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.postSubscriptionDetailsArray.map((item, index) => {
                                                if (item != undefined) {
                                                    return (

                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td className="td-dense">
                                                                {
                                                                    this.getCurrentStatusComponent(index, item['verificationStatus'], item['importStatus'])
                                                                }
                                                            </td>

                                                            {
                                                                this.state.postSubscriptionHeadersArray.map((keys, cellIndex) => {
                                                                    // Determine if the row is disabled based on the status
                                                                    const isRowDisabled = item['importStatus'] === 'success';
                                                                    return (
                                                                        <td className={this.state.currentErrorObject['row'] == index ? "td-dense-highlight" : "td-dense"}>
                                                                            <div className={this.state.currentErrorObject['row'] == index ? "table-row-highlighter" : ""}>
                                                                                {keys == "Periodical Title*" ?
                                                                                    <>
                                                                                        {/* <Select
                                                                                            options={Object.values(this.state.periodicalList).map((data) => ({
                                                                                                value: data.periodicalUID,
                                                                                                label: data.title
                                                                                            }))}
                                                                                            onChange={(e) => {
                                                                                                this.getValueOfRowInputs(index, 'periodicalId', e, keys);
                                                                                            }}
                                                                                            onInputChange={(inputValue) => {
                                                                                                this.setState({ PeriodicalTitle: inputValue }, () => {
                                                                                                    this.getPeriodicalList();
                                                                                                }, 200);
                                                                                            }}
                                                                                            isSearchable
                                                                                            isLoading={this.state.periodicalsLoading} // Show loading spinner while fetching
                                                                                            value={item['periodicalId']}
                                                                                            placeholder="Select Periodical Name"
                                                                                            styles={{
                                                                                                control: (base) => ({
                                                                                                    ...base,
                                                                                                    minHeight: 42, // Minimum height for the control area
                                                                                                    height: 'auto', // Allow control to grow dynamically,
                                                                                                    fontSize: "13px",
                                                                                                    fontWeight: 400,
                                                                                                }),
                                                                                                option: (base, state) => ({
                                                                                                    ...base,
                                                                                                    fontSize: "13px",
                                                                                                    fontWeight: 400,
                                                                                                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                                                    color: state.isSelected ? '#333' : '#555',
                                                                                                }),
                                                                                                menu: (base) => ({
                                                                                                    ...base,
                                                                                                    zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                                                    // maxHeight: '200px', // Limit the height of the dropdown
                                                                                                    overflowY: 'auto', // Enable scrolling inside the dropdown if it exceeds maxHeight
                                                                                                    position: 'absolute', // Fix the position to avoid getting cut off
                                                                                                }),
                                                                                                menuPortal: (base) => ({
                                                                                                    ...base,
                                                                                                    zIndex: 9999, // Ensure the menu is above other modal content
                                                                                                }),
                                                                                                placeholder: (base) => ({
                                                                                                    ...base,
                                                                                                    fontSize: '14px',
                                                                                                    fontWeight: '400', // Use fontWeight for normal text

                                                                                                }),
                                                                                            }}
                                                                                            menuPortalTarget={document.body}
                                                                                            noOptionsMessage={() => (this.state.periodicalsLoading ? "Loading..." : "No options found")}
                                                                                        /> */}

                                                                                        <select
                                                                                            id="series-selction"
                                                                                            value={item[keys]}
                                                                                            className="form-control"
                                                                                            onChange={(e) => {
                                                                                                this.getValueOfRowInputs(index, keys, e.target.value, keys);
                                                                                            }}
                                                                                            disabled={isRowDisabled}
                                                                                        >
                                                                                            <option value="">Select Periodical</option>
                                                                                            {
                                                                                                Object.values(this.state.ImportPeriodicalList).map((data) =>
                                                                                                    (<option key={data.periodicalUID} value={data.title} title={data.title}>{data.title}</option>)
                                                                                                )
                                                                                            }
                                                                                        </select>
                                                                                        <span class="text-danger">{item[keys] ? null : `Please select valid ${keys}`}</span>
                                                                                    </>
                                                                                    : keys == "Vendor" ?
                                                                                        <>
                                                                                            <select
                                                                                                id="series-selction"
                                                                                                value={item[keys]}
                                                                                                className="form-control"
                                                                                                style={{ width: '200px' }}
                                                                                                onChange={(e) => {
                                                                                                    this.getValueOfRowInputs(index, keys, e.target.value, keys);
                                                                                                }}
                                                                                                disabled={isRowDisabled}
                                                                                            >
                                                                                                <option value="">Select Vendor</option>
                                                                                                {
                                                                                                    Object.keys(this.state.ImportVendorList).map(vendor => {
                                                                                                        let vendorName = this.state.ImportVendorList[vendor]

                                                                                                        return (
                                                                                                            <option style={{ fontSize: '13px' }} value={vendorName.displayname} title={vendorName.displayname}>{vendorName.displayname}</option>
                                                                                                        );
                                                                                                    })
                                                                                                }
                                                                                            </select>
                                                                                            <span>{item[keys] ? null : `Invalid ${keys}`}</span>
                                                                                        </>
                                                                                        :
                                                                                        <>
                                                                                            <input
                                                                                                type='text'
                                                                                                placeholder={`Enter ${keys}`}
                                                                                                value={item[keys]}
                                                                                                ref={(el) => this.tableObject[`${index}-${cellIndex}`] = el}
                                                                                                style={{ width: '200px' }} // Correct way to apply inline style as an object
                                                                                                className="form-control filterInput"
                                                                                                onChange={(e) => {
                                                                                                    this.getValueOfRowInputs(index, keys, e.target.value, keys);
                                                                                                }}
                                                                                                disabled={isRowDisabled}
                                                                                            />
                                                                                            {keys == "Subscription Start Date*" || keys == "Subscription End Date*" || keys == "Average Price Per Copy*" ?
                                                                                                <span class="text-danger">{item[keys] ? null : `Please enter ${keys}`}</span> : null}
                                                                                        </>
                                                                                }
                                                                            </div>
                                                                        </td>
                                                                    )
                                                                })
                                                            }
                                                        </tr>
                                                    )
                                                }
                                            })
                                        }

                                    </tbody>
                                </table>
                            </div>
                        ) : <p>Data is not available.</p>
                    }
                </div>
                <p><span className="text-danger my-2 font-size14">*</span>Note : Errors are indicated by red boxes. Please click on the red boxes to correct them. </p>

                <div className="inspect-console">
                    <div className="table-responsive">
                        <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                            <thead>
                                <tr>
                                    <th rowSpan={2} style={{ verticalAlign: "middle", textAlign: "center" }}>
                                        <div className="import-progress">
                                            {
                                                this.state.importProgress.map((item, index) => {
                                                    return (
                                                        <div className="tab-wrapper">
                                                            <div className="step-wrapper">
                                                                <span className={this.state.currentProgress == index ? "circle-tab" : "circle-tab-muted"} style={this.checkImportTabProgress(index) ? { background: "green", color: "#FFF" } : {}}>{index + 1}</span>
                                                                {index < this.state.importProgress.length - 1 && <span className={this.state.validations['isVerified'] ? "step-line bg-success" : "step-line "}></span>}
                                                            </div>
                                                            <p className={this.state.currentProgress == index ? "mb-0 mx-2" : "mb-0 mx-2 text-muted"}>{item.name}</p>
                                                        </div>

                                                    )
                                                })
                                            }
                                        </div>
                                    </th>

                                    <th>
                                        <div className="d-flex justify-content-between align-items-center" >
                                            <span onClick={() => {
                                                this.state.currentPointer > 0 && this.navigateToPreviousError()
                                            }} disabled={true} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={['fas', 'arrow-left']} size="md"></FontAwesomeIcon></span>
                                            <p className="mb-0 font-weight-bold">Error Location :
                                                {Object.keys(this.state.currentErrorObject).length > 0 &&
                                                    `Rows : ${this.state.currentErrorObject['row'] + 1} Columns : ${this.state.currentErrorObject['key']}`
                                                }
                                            </p>
                                            <span onClick={() => {
                                                this.state.currentPointer < this.state.errorLogs.length && this.navigateToNextError()
                                            }} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={['fas', 'arrow-right']} size="md"></FontAwesomeIcon></span>
                                        </div>
                                    </th>
                                </tr>
                                <tr>

                                    <th align="center" style={{ verticalAlign: "middle", textAlign: "center" }}>
                                        {
                                            this.state.errorLogs.length > 0 ?
                                                (
                                                    <div>{this.ErrorViewConsole()}</div>
                                                )
                                                : <span className="initial-preview"><FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999"></FontAwesomeIcon><p className="mx-2 mb-0">After verification, You can view content which has errors.</p></span>
                                        }
                                        {/* 
                                        {
                                            this.state.errorMessageObjArray?.length > 0 ?
                                                this.state.errorMessageObjArray?.map((row) => {
                                                    let rowIndex = row['rowIndex'];
                                                    let message = row['message'];
                                                    return <div>Row : {rowIndex} | Error : {message}</div>;
                                                })
                                                :
                                                <span className="initial-preview">
                                                    <FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999" />
                                                    <p className="mx-2 mb-0">After verification, You can view content which has errors.</p>
                                                </span>
                                        } */}

                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </>
        )
    }

    // 	GET CURRENT STATUS COMPONENT
    getCurrentStatusComponent = (index, verificationStatus = "pending", importStatus = "pending") => {
        {
            return this.state.importPointer['rowindex'] == index ?
                <div>
                    {
                        this.state.importPointer['loading'] ?
                            <div class="spinner-border spinner-border-sm" role="status" >
                                <span class="sr-only">{this.state.importPointer['status']}...</span>
                            </div>
                            :
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div>{this.state.importPointer['status']}</div>
                                {/* {
                                    this.state.importPointer['status'] == 'failed' &&
                                    // importStatus == 'failed' &&
                                    <button type="button" className="btn import-btn" disabled={this.state.importProgressSummary['failed'] == 0} onClick={() =>
                                        this.setState({
                                            loadingImportProcess: true
                                        }, () => {
                                            this.apiCallToImportVerifySubscriptionDetails(index, this.state.importProgressSummary, 'true')
                                        })
                                    }>
                                        Retry
                                    </button>
                                } */}
                            </div>

                    }

                </div>

                : <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div>{importStatus}</div>

                    {/* {
                        // this.state.importPointer['status'] == 'failed' &&
                        importStatus == 'failed' &&
                        <button type="button" className="btn import-btn" disabled={this.state.importProgressSummary['failed'] == 0} onClick={() =>
                            this.setState({
                                loadingImportProcess: true
                            }, () => {
                                // this.apiCallToImportVerifySubscriptionDetails(index, this.state.importProgressSummary, 'true')
                            })
                        }>
                            Retry
                        </button>
                    } */}
                </div>
        }
    }

    //function to download prerequisite data 
    downloadPrerequisitedataCSV = () => {
        let preRequisiteData = this.state.preRequisiteCSVDataForFaculty
        let preRequisiteHeaders = this.state.preRequisiteCSVHeadersForFaculty

        // For Vender
        if (Object.values(this.state.vendorList).length > 0) {
            Object.keys(this.state.vendorList).map((stream, index) => {
                let vender = this.state.vendorList[stream]
                if (vender != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].vender = vender.displayname
                    } else {
                        preRequisiteData.push({ periodical: '', vender: vender.displayname })
                    }
                }
            })
        }

        // For periodical list
        if (Object.values(this.state.periodicalList).length > 0) {
            Object.keys(this.state.periodicalList).map((Id, index) => {
                let category = this.state.periodicalList[Id]
                if (category != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].periodical = category.title
                    } else {
                        preRequisiteData.push({ periodical: category.title, vender: '' })
                    }
                }
            })
        }

        this.setState({
            preRequisiteData: preRequisiteData,
            preRequisiteHeaders: preRequisiteHeaders,
        })
    }
    // Strip HTML
    stripHtml(html) {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    //FUNCTION DEFINED TO GET THE INPUT OF THE IMPORTED CSV
    handleCSVInput = (csvData, fileInformation) => {
        let periodicalId = "";
        let venderId = "";
        this.setState({
            selectedCSVFiles: fileInformation
        })

        if (fileInformation.type !== "text/csv") {
            this.setState({
                selectedCSVFiles: {},
                successModal: true,
                successModalType: "error",
                successMessage: "Please select csv file.",
                isValidAttachment: false
            })
        } else {
            let postSubscriptionDetailsArray = [];
            let postSubscriptionHeadersArray = [];

            if (csvData.length > 0) {
                csvData = csvData.filter((rowArray, index) => rowArray.length > 1 && !rowArray.every((val) => val == ""));

                // Read CSV Headers
                let headers = csvData[0];

                if (headers != undefined && headers.length > 0) {
                    headers.map((headerName, index) => {
                        if (headerName != undefined && headerName.trim() !== "") {
                            postSubscriptionHeadersArray.push(headerName.trim());
                        }
                    })
                } else {
                    toast.warn("Invalid headers found in imported excel file.", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

                // // Read CSV Headers
                // let headers = csvData[0];

                // if (headers != undefined && headers.length > 0) {
                //     headers.map((headerName, index) => {
                //         if (headerName != undefined) {
                //             postSubscriptionHeadersArray.push(headerName.trim());
                //         }
                //     })
                // }

                // Read CSV Actual Body Data
                if (postSubscriptionHeadersArray.length > 0) {
                    csvData.map((csvRow, index) => {
                        if (index != 0) {
                            let subscriptionObject = {};

                            for (let i = 0; i < postSubscriptionHeadersArray.length; i++) {

                                if (csvRow[i] == undefined || csvRow[i] == null || csvRow[i] == "") {
                                    subscriptionObject[postSubscriptionHeadersArray[i]] = "";
                                } else {
                                    subscriptionObject[postSubscriptionHeadersArray[i]] = csvRow[i];
                                }
                            }

                            // periodically unique ID
                            periodicalId = subscriptionObject['Periodical Title*'] ?
                                (Object.values(this.state.periodicalList).find(po => (po.title) == subscriptionObject['Periodical Title*'])?.periodicalUID || '')
                                : '';

                            subscriptionObject['periodicalId'] = periodicalId;

                            // vendor unique ID
                            // Using Object methods to find the vendor ID
                            const findVendorId = (vendorName) => {
                                return Object.keys(this.state.vendorList).find(id => this.state.vendorList[id].displayname === vendorName) || "";
                            };

                            venderId = findVendorId(subscriptionObject['Vendor']);

                            subscriptionObject['vendor'] = venderId;

                            postSubscriptionDetailsArray.push({ ...subscriptionObject, verificationStatus: "pending", importStatus: "pending", loading: false });
                        }
                    })
                }
            }

            this.setState({
                csvData: [...csvData],
                postSubscriptionDetailsArray: postSubscriptionDetailsArray,
                postSubscriptionHeadersArray: postSubscriptionHeadersArray
            }, () => {
                this.validateCSVFileHeaders();

            })
        }
    }

    // VALIDATE CSV FILE HEADERS
    validateCSVFileHeaders = () => {
        let commonHeaders = ["Periodical Title*", "Vendor", "Subscription Start Date*", "Subscription End Date*", "Number Of Expected Issues", "Average Price Per Copy*"]
        let mandatoryHeaders = ["Periodical Title*", "Subscription Start Date*", "Subscription End Date*", "Average Price Per Copy*"]
        let postSubscriptionHeadersArray = this.state.postSubscriptionHeadersArray;
        let validations = this.state.validations;

        if (postSubscriptionHeadersArray.length > 0) {
            // Checking Default subscription Headers are available or not.
            mandatoryHeaders.map((header, index) => {
                if (!postSubscriptionHeadersArray.includes(header)) {
                    let validationObject = {
                        touch: true,
                        cell: index + 1,
                        row: 0,
                        status: "error",
                        message: `${header} is mandatory column to import subscription.`,
                        type: "header",
                        errorCount: 0
                    }
                    validations['headersErrors'].push(validationObject)
                    validations['isHeadersValid'] = false;
                }
            })

            // Checking Dyanamic subscription Headers are available or not.
            postSubscriptionHeadersArray.map((key, index) => {
                let validationObject = {
                    touch: false,
                    cell: 0,
                    row: 0,
                    status: "error",
                    message: "",
                    type: "header",
                    errorCount: 0
                }

                let isValidHeader = commonHeaders.some((keys) => {
                    return keys == key.trim();
                })

                if (!isValidHeader) {
                    validationObject.cell = index;
                    validationObject.status = "error";
                    validationObject.message = `Please check default headers. ${key} header is invalid.`;
                    validationObject.touch = true;
                }


                if (validationObject.touch) {
                    validations['headersErrors'].push(validationObject)
                    validations['isHeadersValid'] = false;
                }

            })
        }


        if (validations['headersErrors'].length == 0) {
            validations['isHeadersValid'] = true;
        }

        this.setState({
            validations: { ...validations }
        })
    }

    // VALIDATE CSV FILE DATA
    validateCSVFileData = () => {
        let postSubscriptionDetailsArray = this.state.postSubscriptionDetailsArray;
        let postSubscriptionHeadersArray = this.state.postSubscriptionHeadersArray;
        let validations = { ...this.state.validations, dataErrors: {}, errors: [], isDataValid: false, isVerified: false };
        let verificationSummary = {
            completed: 0,
            failed: 0,
            total: 0,
            pending: 0
        };

        verificationSummary['total'] = postSubscriptionDetailsArray.length;
        verificationSummary['pending'] = postSubscriptionDetailsArray.length;
        let verificationPointer = this.state.verificationPointer;

        postSubscriptionDetailsArray.map((item, rowIndex) => {
            let status = true;
            let hasEarning = true;
            verificationPointer['loading'] = true;
            verificationPointer['status'] = 'verfying';
            verificationPointer['rowindex'] = rowIndex;
            this.setState({
                verificationPointer: verificationPointer
            })

            verificationSummary['pending'] -= verificationSummary['pending'];

            postSubscriptionHeadersArray.map((key, cellIndex) => {
                let validationObject = {
                    touch: false,
                    cell: 0,
                    row: 0,
                    key: "",
                    cellName: "",
                    status: "error",
                    message: "",
                    type: "data",
                    errorCount: 0
                }

                if (validationObject.touch) {
                    status = false;
                    if (validations['dataErrors'][rowIndex] == undefined) {
                        validations['dataErrors'][rowIndex] = {};
                        validations['dataErrors'][rowIndex][validationObject.cell] = validationObject;

                    } else {
                        validations['dataErrors'][rowIndex][validationObject.cell] = validationObject;
                    }
                    item['verificationStatus'] = "failed";
                    validations['isDataValid'] = false;
                }
            })

            if (hasEarning) {
                validations['errors'].push({
                    touch: true,
                    cell: 0,
                    row: rowIndex,
                    key: "",
                    cellName: "",
                    status: "error",
                    message: "Please enter atleast one earning component",
                    type: "basic",
                    errorCount: 1
                })

                verificationPointer['status'] = 'failed';
                postSubscriptionDetailsArray[rowIndex]['verificationStatus'] = 'failed';
                verificationPointer['loading'] = false;
            } else {
                verificationPointer['status'] = status ? 'verified' : 'failed';
                postSubscriptionDetailsArray[rowIndex]['verificationStatus'] = verificationPointer['status'];
                verificationPointer['loading'] = false;
            }

            verificationSummary['failed'] = Object.keys(validations['dataErrors']).length;
            verificationSummary['completed'] = (verificationSummary['total'] - verificationSummary['pending']) - verificationSummary['failed'];

            this.setState({
                postSubscriptionDetailsArray: [...postSubscriptionDetailsArray],
                verificationProgress: verificationSummary,
                verificationPointer: verificationPointer,
            })
        })

        if (validations['errors'].length > 0) {
            let failedCount = 0;
            validations['errors'].map(item => {
                if (!Object.keys(validations['dataErrors']).includes(item.row)) {
                    failedCount++;
                }
            })

            verificationSummary['failed'] = Object.keys(validations['dataErrors']).length + failedCount;
            verificationSummary['completed'] = (verificationSummary['total'] - verificationSummary['pending']) - verificationSummary['failed'];
        }


        if (Object.keys(validations['dataErrors']).length == 0 && validations['errors'].length == 0) {
            validations['isDataValid'] = true;
            validations['isVerified'] = true;
            this.setState({
                currentPointer: 1
            })
        }

        this.setState({
            validations: { ...validations },
            verificationProgress: verificationSummary,
            loadingVerificationProcess: false
        }, () => {
            this.getBugLogs();
        })
    }

    // GET VALUES FORM INPUT FIELDS
    getValueOfRowInputs = (rowIndex, key, value, type) => {
        let postSubscriptionDetailsArray = this.state.postSubscriptionDetailsArray;
        let rowObject = postSubscriptionDetailsArray[rowIndex];

        if (key === "Periodical Title*" && Object.values(this.state.ImportPeriodicalList)) {
            const selectedPeriodical = Object.values(this.state.ImportPeriodicalList).find(item => item.title === value);

            if (selectedPeriodical) {
                // Update both "Periodical Title*"
                rowObject["Periodical Title*"] = value;
            }
        } else if (key === "Vendor" && Object.values(this.state.ImportVendorList)) {
            const selectedVendor = Object.values(this.state.ImportVendorList).find(item => item.displayname === value);

            if (selectedVendor) {
                // Update both "Vendor"
                rowObject["Vendor"] = value;
            }
        }

        else {
            // Handle other cases
            if (typeof rowObject[key] == 'object') {
                rowObject[key]['value'] = value; // Update nested value if it's an object
            } else {
                rowObject[key] = value; // Update directly if it's a primitive
            }
        }

        // if (typeof rowObject[key] == 'object') {
        //     rowObject[key]['value'] = value;
        // } else {
        //     rowObject[key] = value;
        // }        

        postSubscriptionDetailsArray[rowIndex] = rowObject;

        this.setState({
            postSubscriptionDetailsArray: postSubscriptionDetailsArray
        })
    }

    // Navigate to previous 
    navigateToPreviousError = () => {
        let errorLogs = this.state.errorLogs;
        let currentPointer = this.state.currentPointer;
        let currentErrorObject = {};

        if (currentPointer > 0) {
            currentPointer -= 1;
            currentErrorObject = errorLogs[currentPointer];
            this.setState({
                currentPointer: currentPointer,
                currentErrorObject: currentErrorObject
            }, () => {
                let { row, cell, key } = this.state.currentErrorObject;
            })
        }

    }

    // Navigate to next
    navigateToNextError = () => {
        let errorLogs = this.state.errorLogs;
        let currentPointer = this.state.currentPointer;
        let currentErrorObject = {};

        if (currentPointer < errorLogs.length - 1) {

            currentPointer += 1;
            currentErrorObject = errorLogs[currentPointer];

            this.setState({
                currentPointer: currentPointer,
                currentErrorObject: currentErrorObject
            }, () => {
                let { row, cell, key } = this.state.currentErrorObject;
            })
        }
    }

    // CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
            successModalType: "",
            successMessage: ""
        })
    }

    // CONSOLE ERROR 
    ErrorViewConsole = () => {
        let { row, message } = this.state.currentErrorObject;
        return (
            <div>
                {
                    this.state.currentErrorObject['key'] != "" && (
                        <div>
                            <p className="mb-0 font-weight-bold text-danger">{this.state.currentErrorObject['message']}</p>
                        </div>
                    )

                }
            </div>
        )
    }

    // API CALL TO IMPORT VERIFY SUBSCRIPTION
    apiCallToImportVerifySubscriptionDetails = async (rowIndex = 0, importProgressSummary = { completed: 0, failed: 0, total: 0, pending: 0 }, isRetry = "") => {

        if (rowIndex < this.state.postSubscriptionDetailsArray.length) {
            let subscriptionData = this.state.postSubscriptionDetailsArray[rowIndex];
            let importPointer = this.state.importPointer;
            importPointer['loading'] = true;
            importPointer['status'] = 'importing';
            importPointer['rowindex'] = rowIndex;
            this.setState({
                importPointer: importPointer,
            })

            let errorLogs = this.state.errorLogs;

            let selectedPeriodicalData = Object.values(this.state.ImportPeriodicalList).find(item => item.title === subscriptionData['Periodical Title*']);


            let selectedVendorData = Object.keys(this.state.ImportVendorList).find(vendorId => {
                return this.state.ImportVendorList[vendorId].displayname === subscriptionData['Vendor'];
            });

            // let periodicalValue = subscriptionData['periodicalId'] ? subscriptionData['periodicalId'].value : '';
            let periodicalValue = selectedPeriodicalData ? selectedPeriodicalData?.periodicalUID : '';
            let venderValue = selectedVendorData !== undefined ? selectedVendorData : '';
            let startDateValue = subscriptionData['Subscription Start Date*'] ? subscriptionData['Subscription Start Date*'].trim() : '';
            let endDateValue = subscriptionData['Subscription End Date*'] ? subscriptionData['Subscription End Date*'].trim() : '';
            let expectedIssuesValue = subscriptionData['Number Of Expected Issues'] ? subscriptionData['Number Of Expected Issues'] : '';
            let avgPricePerCopyValue = subscriptionData['Average Price Per Copy*'] ? subscriptionData['Average Price Per Copy*']: '';

            let requestData = {
                "iid": this.state.iidImportSubscription, // config.institute_id,
                "periodicalId": periodicalValue,
                "vendorId": venderValue,
                "startDate": startDateValue,
                "endDate": endDateValue,
                "expectedIssues": expectedIssuesValue,
                "avgPricePerCopy": avgPricePerCopyValue,
                "facultyId": config.faculty_id,
                "iidArray": this.props.iidArray.iidArray
            }

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'library_VerifyImportSubscription',
                requestData,
                "/api/library/instructor.php"
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.apiCallToImportVerifySubscriptionDetails(rowIndex, importProgressSummary, isRetry);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;
                    // set response
                    this.setState({
                        verifyImportSubscriptionResult: apiResult
                    })
                    if (apiResult.status == 'success') {
                        let postSubscriptionDetailsArray = this.state.postSubscriptionDetailsArray;
                        let rowItem = postSubscriptionDetailsArray[rowIndex];

                        rowItem['status'] = 'completed'
                        postSubscriptionDetailsArray[rowIndex] = rowItem;

                        importProgressSummary['completed'] += 1;
                        if (isRetry != "true") {

                            importProgressSummary['pending'] -= 1;
                        } else {
                            importProgressSummary['failed'] -= 1;
                        }

                        importPointer['status'] = 'success';
                        postSubscriptionDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                        importPointer['loading'] = false;


                        let findIndex = errorLogs.findIndex(obj => obj.row == rowIndex)

                        if (findIndex != -1) {
                            errorLogs.splice(findIndex, 1);
                        }


                        this.setState({
                            postSubscriptionDetailsArray: postSubscriptionDetailsArray,
                            importProgressSummary: importProgressSummary,
                            importPointer: importPointer,
                            currentPointer: 0,
                            currentErrorObject: errorLogs.length > 0 ? errorLogs[0] : {}
                        }, () => {
                            if (isRetry != "true") {

                                this.apiCallToImportVerifySubscriptionDetails(rowIndex + 1, importProgressSummary, isRetry);
                            }
                        })

                    }
                    else {
                        // let rowIndex = rowIndex + 1;
                        let errorObj = {};
                        errorObj['row'] = rowIndex;
                        errorObj['key'] = apiResult.key;
                        errorObj['message'] = apiResult.message;

                        // errorLogs.push(errorObj);

                        let foundIndex = errorLogs.findIndex(obj => obj.row == rowIndex);
                        if (foundIndex != -1) {
                            errorLogs[foundIndex] = errorObj;
                        }
                        else {
                            errorLogs.push(errorObj);
                        }

                        // currentErrorObject['rowIndex'] = rowIndex + 1;
                        // currentErrorObject['key'] = apiResult.key;
                        // currentErrorObject['message'] = apiResult.message;
                        let postSubscriptionDetailsArray = this.state.postSubscriptionDetailsArray;
                        let rowItem = postSubscriptionDetailsArray[rowIndex];
                        rowItem['status'] = 'failed';
                        postSubscriptionDetailsArray[rowIndex] = rowItem;
                        if (isRetry != "true") {
                            importProgressSummary['failed'] += 1;
                            importProgressSummary['pending'] -= 1;
                        }

                        importPointer['status'] = 'failed';

                        postSubscriptionDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                        importPointer['loading'] = false;

                        this.setState({
                            postSubscriptionDetailsArray: postSubscriptionDetailsArray,
                            importProgressSummary: importProgressSummary,
                            importPointer: importPointer,
                            currentErrorObject: errorLogs[0],
                            currentPointer: 0,
                        }, () => {
                            if (isRetry != "true") {

                                this.apiCallToImportVerifySubscriptionDetails(rowIndex + 1, importProgressSummary, isRetry);
                            }
                        })

                    }
                }
                else {
                    let postSubscriptionDetailsArray = this.state.postSubscriptionDetailsArray;
                    importProgressSummary['failed'] += 1;
                    importPointer['status'] = 'failed';
                    postSubscriptionDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                    importPointer['loading'] = false;

                    this.setState({
                        postSubscriptionDetailsArray: postSubscriptionDetailsArray,
                        importProgressSummary: importProgressSummary,
                        importPointer: importPointer,
                        currentPointer: 0,
                    }, () => {

                        if (isRetry != "true") {

                            this.apiCallToImportVerifySubscriptionDetails(rowIndex + 1, importProgressSummary, isRetry);
                        }
                    })

                }
            }

        } else {
            this.setState({
                loadingImportProcess: false
            })
        }
    }

    // API CALL TO IMPORT SUBSCRIPTION DATA
    apiCallToAddSubscriptionDetails = async (rowIndex = 0) => {

        if (rowIndex < this.state.postSubscriptionDetailsArray.length) {
            let subscriptionData = this.state.postSubscriptionDetailsArray[rowIndex];

            let selectedPeriodicalData = Object.values(this.state.ImportPeriodicalList).find(item => item.title === subscriptionData['Periodical Title*']);

            let selectedVendorData = Object.keys(this.state.ImportVendorList).find(vendorId => {
                return this.state.ImportVendorList[vendorId].displayname === subscriptionData['Vendor'];
            });

            // let periodicalValue = subscriptionData['periodicalId'] ? subscriptionData['periodicalId'].value : '';
            let periodicalValue = selectedPeriodicalData ? selectedPeriodicalData?.periodicalUID : '';
            let venderValue = selectedVendorData !== undefined ? selectedVendorData : '';
            let startDateValue = subscriptionData['Subscription Start Date*'] ? subscriptionData['Subscription Start Date*'].trim() : '';
            let endDateValue = subscriptionData['Subscription End Date*'] ? subscriptionData['Subscription End Date*'].trim() : '';
            let expectedIssuesValue = subscriptionData['Number Of Expected Issues'] ? subscriptionData['Number Of Expected Issues'] : '';
            let avgPricePerCopyValue = subscriptionData['Average Price Per Copy*'] ? subscriptionData['Average Price Per Copy*'] : '';

            let subscriptionArray = [{
                "id": 1,
                "vendor": venderValue,
                "startDate": startDateValue,
                "startDateWarning": "",
                "endDate": endDateValue,
                "endDateWarning": "",
                "expectedIssues": expectedIssuesValue,
                "avgPricePerCopy": avgPricePerCopyValue,
                "subUniqueid": "",
                "addOrUpdateKey": "",
                "mandatoryWarning": ""
            }]

            let requestData = {
                "iid": this.state.iidImportSubscription, // config.institute_id,
                "facultyId": config.faculty_id,
                "periodicalId": periodicalValue,
                "subscriptionArray": subscriptionArray
            };

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'library_AddSubscriptionDetails',
                requestData,
                "/api/library/libraryPeriodicals.php"
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.apiCallToAddSubscriptionDetails(rowIndex);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;
                    if (apiResult.status == 'success') {
                        // toast.success(apiResult.message, {
                        //     position: "top-right",
                        //     autoClose: 2000,
                        //     hideProgressBar: false,
                        //     closeOnClick: true,
                        //     pauseOnHover: true,
                        //     draggable: true,
                        //     progress: undefined,
                        // });
                        this.apiCallToAddSubscriptionDetails(rowIndex + 1);
                        // this.setState({
                        //     successModal: true,
                        //     successModalType: 'success',
                        //     successMessage: apiResult.message
                        // }, () => {
                        //     this.apiCallToAddSubscriptionDetails(rowIndex + 1);
                        // });
                    }
                    else {
                        toast.warn(apiResult.message, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        this.apiCallToAddSubscriptionDetails(rowIndex + 1);
                        // this.setState({
                        //     successModal: true,
                        //     successModalType: 'warning',
                        //     successMessage: apiResult.message
                        // }, () => {
                        //     this.apiCallToAddSubscriptionDetails(rowIndex + 1);
                        // });
                    }
                }
                else {
                    toast.error('Something went wrong while adding bill. Please try again later.', {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.apiCallToAddSubscriptionDetails(rowIndex + 1);
                    // this.setState({
                    //     successModal: true,
                    //     successModalType: 'error',
                    //     successMessage: 'Something went wrong while adding bill. Please try again later.'
                    // }, () => {
                    //     this.apiCallToAddSubscriptionDetails(rowIndex + 1);
                    // });
                }
            }

        } else {
            this.setState({
                loadingImportSubscriptionProcess: false,
                isImportButtonDisabled: true
            })
            // common success message
            toast.success("Subscription data imported successfully.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    checkImportStatus = () => {
        return this.state.postSubscriptionDetailsArray.some((item, index) => item.importStatus == 'success')
    }

    checkImportTabProgress = (index) => {
        if (index == 0) {
            return this.state.validations['isVerified']
        } else if (index == 1) {
            return this.checkImportStatus()
        }
    }

    render() {
        return (
            <>
                {/* <FontAwesomeIcon size='sm' style={{ color: '#0465AC', cursor: 'pointer' }} title="Click here to import Subscription" icon={["fa", "file-import"]} onClick={this.openImportSubscriptionModal} /> */}

                {this.importSubscriptionModal()}
                <div id="exportList"></div>
                <SuccessModal
                    successModal={this.state.successModal}
                    successModalType={this.state.successModalType}
                    successMessage={this.state.successMessage}
                    closeSuccessModal={this.closeSuccessModal}
                />

            </>
        )
    }
}

const ProgressBar = (props) => {
    const { bgcolor, completed, failed, pending, total } = props;

    let pendingProgressWidth = (pending / total) * 100;
    let completedProgressWidth = (completed / total) * 100;
    let failedProgressWidth = (failed / total) * 100;


    const containerStyles = {
        // height: 15,
        width: '100%',
        backgroundColor: "#e0e0de",
        margin: '0.2em 0',
        display: 'flex',
    }

    const fillerStyles = {
        height: '100%',
        borderRadius: 'inherit',
        textAlign: 'right',
        transition: 'width 1s ease-in-out',
    }

    const labelStyles = {
        padding: 5,
        color: 'white',
        fontWeight: 'bold',
        fontSize: '14px'
    }
    const completedProgress = {
        width: `${completedProgressWidth}%`,
        backgroundColor: 'green'
    }


    const failedProgress = {
        width: `${failedProgressWidth}%`,
        backgroundColor: 'tomato'
    }

    const pendingProgress = {
        width: `${pendingProgressWidth}%`,
        backgroundColor: 'orange'
    }
    return (
        <div style={containerStyles}>
            {
                total > 0 && (<>
                    <div style={{ ...fillerStyles, ...completedProgress }}>
                        <span style={labelStyles}>{`${completedProgressWidth}%`}</span>
                    </div>
                    <div style={{ ...fillerStyles, ...failedProgress }}>
                        <span style={labelStyles}>{`${failedProgressWidth}%`}</span>
                    </div>
                    <div style={{ ...fillerStyles, ...pendingProgress }}>
                        <span style={labelStyles}>{`${pendingProgressWidth}%`}</span>
                    </div>
                </>)
            }

        </div>
    );
};


const mapStateToProps = store => {
    return {
        // VARIABLES TO GET admin DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin,
        iidArray: { ...store.RouteMenuReducer.iidArray },
        multipleInstituteDetails: { ...store.RouteMenuReducer.multipleInstituteDetails }
    };
};

export default connect(mapStateToProps)(ImportSubscription);